import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            name: 'page-header',
            key: 'c1',
            props: {
                header: {
                    title: '',
                },
                rhsComponents: [],
            },
        },
        {
            name: 'tableau-wrapper',
            key: 'c2',
            props: {},
            fromStore: [{ key: 'appData', value: 'menuStructure' }],
        },
    ],
};
